import React from 'react';
import { IndexRoute, Route } from 'react-router';
import { IndexContainer } from './components/index/index';
import { NotFoundContainer } from './components/not-found/not-found';
import { ProfileContainer } from './components/profile/profile';
import { JobsContainer } from './components/jobs/jobs';
import { JobFormContainer } from './components/jobs/job-form';
import { requireAuth } from './helpers/auth';

export default () => (
  <Route path="/">
    <IndexRoute component={IndexContainer} />
    <Route path="/profile" component={ProfileContainer} onEnter={requireAuth} />
    <Route path="/jobs" component={JobsContainer} onEnter={requireAuth} />
    <Route
      path="/jobs/:jobid"
      component={JobFormContainer}
      onEnter={requireAuth}
    />
    <Route
      path="/create-job"
      component={JobFormContainer}
      onEnter={requireAuth}
    />
    <Route path="/*" component={NotFoundContainer} />
  </Route>
);



/** WEBPACK FOOTER **
 ** ./src/routes.js
 **/